import { Box, ButtonBase, Divider, IconButton, Tooltip, Typography, Button, Chip } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import React, { useState } from "react";
import DoneAllTwoToneIcon from '@mui/icons-material/DoneAllTwoTone';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import AudioSelector from './AudioSelector';

function VideoCard({ video, handleAdd = undefined, onDelete = undefined, _component = ButtonBase, sx, onAudioSelect, audio_track = true }) {
  const [audioSelectorOpen, setAudioSelectorOpen] = useState(false);

  const handleAudioButtonClick = (e) => {
    e.stopPropagation();
    setAudioSelectorOpen(true);
  };

  const handleAudioSelect = (audio, remove = false) => {
    if (onAudioSelect) {
      onAudioSelect(audio, remove);
    }
  };

  return (
    <Box
      component={_component}
      onClick={handleAdd && handleAdd(video)}
      key={video.unique_key}
      sx={{ border: "0.5px solid #d3d3d3", ...sx }}
      display="flex"
      flexDirection="column"
      borderRadius={2}
      gap={1}
      p={1}
      width="100%"
    >

      {onDelete && (
        <Box width="100%" display="flex" justifyContent="space-between" alignItems="center">
          <IconButton size="small" onClick={() => onDelete(video)}>
            <ClearIcon fontSize="small" />
          </IconButton>
          <IconButton size="small" disabled>
            <DoneAllTwoToneIcon color="success" fontSize="small" />
          </IconButton>
        </Box>
      )
      }
      <Box textAlign="center" height={200} width={"100%"}>
        <Box
          borderRadius={2}
          component="video"
          controls
          loading="lazy"
          height={"100%"}
          minWidth={"100%"}
          maxWidth={"100%"}
          src={video.s3_url}
        />
      </Box>
      <Box display="flex" flexDirection="column" width="100%" minHeight={60}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2" color="gray" align="left" >
            {video.unique_key}
          </Typography>
          {video.created_at &&
            <Typography variant="subtitle2" color="gray">{new Date(video.created_at).toDateString()}</Typography>
          }
        </Box>
        <Divider flexItem variant="middle" />
        {video.description ?
          <Tooltip title={video.description}>
            <Typography variant="body2" align="left">{video.title ? video.title : video.video_title}</Typography>
          </Tooltip> :
          <Typography variant="body2" align="left">{video.title ? video.title : video.video_title}</Typography>
        }

        {/* Audio Selection Section - Only show for selected videos */}
        {audio_track && onDelete && (
          <>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography variant="caption" color="textSecondary" >
                Audio Track : <strong style={{ textDecoration: "underline" }}>{video?.audio ? video.audio.title : ""}</strong>
              </Typography>

              {video.audio ? (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <Chip
                    icon={<AudioFileIcon />}
                    label={video.audio.title}
                    color="primary"
                    size="small"
                    sx={{ maxWidth: "180px" }}
                    onDelete={() => { handleAudioSelect(video.audio, true) }}
                  />
                  <Button
                    size="small"
                    onClick={handleAudioButtonClick}
                    variant="outlined"
                    sx={{ fontSize: "0.7rem", minWidth: "auto", px: 1 }}
                  >
                    Change
                  </Button>
                </Box>
              ) : (
                <Button
                  size="small"
                  startIcon={<AudioFileIcon />}
                  onClick={handleAudioButtonClick}
                  variant="outlined"
                  color="primary"
                  sx={{
                    fontSize: "0.75rem",
                    height: 32,
                    borderStyle: "dashed",
                    "&:hover": {
                      borderStyle: "solid"
                    }
                  }}
                >
                  Select Audio
                </Button>
              )}
            </Box>
          </>
        )}

      </Box>

      {/* Audio Selector Dialog */}
      <AudioSelector
        open={audioSelectorOpen}
        onClose={() => setAudioSelectorOpen(false)}
        onSelect={handleAudioSelect}
      />
    </Box >
  );
}

export default VideoCard;
